import { render, staticRenderFns } from "./Diagnostics.vue?vue&type=template&id=6d2ec030"
import script from "./Diagnostics.vue?vue&type=script&lang=js"
export * from "./Diagnostics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports